import React from "react"

// Helpers
import { applyVatRateToLines } from "@shared/quotes/resolveVatRate"

// Quote-wide VAT rate, gated by the `allow_bulk_vat_rate_on_quotes` account
// preference. Picking a rate rewrites every existing line that does not force
// its own rate, and is kept on the quote so lines added later start from it.
// The empty option hands the quote back to the site's rate.
const VatRate = ({quote, replaceQuote}) => {
  const vats     = quote.account.vat_rates || []
  const siteVat  = quote.site?.vat_rate || {}
  const selected = quote.vat_rate?.id || ""

  const onChange = (e) => {
    const vat_rate = vats.find(vat => vat.id == e.target.value) || {}

    if (!confirm(I18n.t("quotes.new.bulk_vat_rate_confirm"))) return

    replaceQuote({
      ...quote,
      vat_rate,
      qlines: applyVatRateToLines(quote.qlines, vat_rate.id ? vat_rate : siteVat)
    })
  }

  return(
    <div className="form-group">
      <label>{I18n.t("quotes.new.bulk_vat_rate")}</label>

      <select
        className = "form-control"
        value     = {selected}
        onChange  = {onChange}
        disabled  = {quote.read_only_vat}
      >
        <option value="">{I18n.t("quotes.new.bulk_vat_rate_site_default")}</option>
        { vats.map(vat => <option key={vat.id} value={vat.id}>{vat.label}</option>) }
      </select>

      <input type="hidden" name="quote[vat_rate_id]" value={selected} />
    </div>
  )
}

export default VatRate
